module.exports = __webpack_public_path__ + "img/cj-aside-entry.3f0bec1f.png";